
import * as THREE from 'three'
import type { GLTF } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { AnimatedObject } from '../core'


/**
 * Clear/stop animations
 */
export const clearAnimations = (actionPlaying: THREE.AnimationAction | null): void => {
  if (actionPlaying && actionPlaying.isRunning()) {
    actionPlaying.stop()
    console.debug("action: '" + actionPlaying.getClip().name + "' stopped")
  }
}

/**
 * Load animation clip
 */
export const loadClip = (
  anims: THREE.AnimationClip[],
  mixer: THREE.AnimationMixer,
  name: string
): THREE.AnimationAction | undefined => {
  try {
    const clip = THREE.AnimationClip.findByName(anims, name)
    if (!clip) return
    const action = mixer.clipAction(clip)
    console.debug("clip loaded:", clip.name, "- durée:", clip.duration.toFixed(2))
    return action
  } catch (err) {
    console.warn("clip not found:", name, err)
    return undefined
  }
}

/**
 * Get all animation actions
 */
export const getActions = (
  gltf: GLTF,
  object: AnimatedObject,
  actionLabels: string[]
): THREE.AnimationAction[] | null => {
  if (gltf.animations.length === 0) {
    console.debug("no animation data", object)
    return null
  }

  object.mixer = new THREE.AnimationMixer(object)
  object.actions = {}
  actionLabels.forEach(label => {
    const action = loadClip(gltf.animations, object.mixer!, label)
    if (action) {
      object.actions![label] = action
    }
  })

  const actionsArray = Object.values(object.actions)
  console.debug("all actions:", actionsArray)

  return actionsArray
}

